
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import authServices from '@/services/auth-services';

@Component({
    components: {
        Loading,
    },
})
export default class Notify extends Vue {
    private isLoading = true;
    get token() {
        try {
            return this.$route.params.token.split('token=')[1];
        } catch {
            return '';
        }
    }

    @Watch('token', { immediate: true, deep: true })
    private async watchToken() {
        if (this.token && this.token.trim() !== '') {
            this.isLoading = true;
            const dataRequest = {
                verify_token: this.token
            };
            const result = await authServices.verifyEmail(dataRequest);

            if (result && result.status === 200 && result.data.status === 200) {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Tài khoản của bạn đã kích hoạt thành công!',
                });
                this.isLoading = false;
            }
        }
    }
}
